<!--
 * @Author: 麦勇潮
 * @Date: 2021-01-04 16:06:46
 * @LastEditors: 麦勇潮
 * @LastEditTime: 2021-01-14 16:33:12
-->
<template>
  <div class="popbox" @click="close()">
    <div class="popbox-container" @click.stop>
      <!-- {{gm_url}} -->
      <span class="kefu-tip">温馨提示</span>
      <br />
      <p class="kefu-tip">{{ gm_url.split('_')[1] }}</p>>
      <div class="btns">
        <span @click="close()">关闭</span>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../store'
import FN from '../utility/fn'
export default {
  data() {
    return {
      gm_url: FN.getSession('SDK_INIT_INFO').help_url
    }
  },
  methods: {
    close() {
      store.dispatch('SET_SDK_COMPONENT_KEFU', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.kefu-tip {
  color: #333;
  text-align: center;
  display: block;
}

.btns {
  width: 4.3rem;
  margin: .5rem auto 0 auto;
  display: flex;
  justify-content: center;

  span {
    color: #fff;
    width: 1.8rem;
    height: .6rem;
    line-height: .6rem;
    text-align: center;
    border-radius: 5px;
    background: orange;
  }

  a {
    background: #219cd2;
    color: #fff;
    width: 1.8rem;
    height: .6rem;
    line-height: .6rem;
    text-align: center;
    border-radius: 5px;
    text-decoration: none;
  }
}

.popbox {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: #fff;
  opacity: 1;
  visibility: visible;
  transition: 0.3s ease;
  background: #33333373;
  display: flex;
  z-index: 101;
  justify-content: center;

  .popbox-container {
    width: 5.86rem;
    padding: 0.4rem 0.3rem;
    margin: auto;
    background: #ececec;
    border-radius: 0.08rem;
    color: #fff;
  }
}
</style>
